import { Option_defaultOrMap } from "../Model/Prelude.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { equals, createObj, int32ToString, round } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { join, printf, toText } from "../fable_modules/fable-library-js.4.29.0/String.js";
import { empty, singleton, append, delay, toList, iterate } from "../fable_modules/fable-library-js.4.29.0/Seq.js";
import { toArray } from "../fable_modules/fable-library-js.4.29.0/Option.js";
import { min, max } from "../fable_modules/fable-library-js.4.29.0/Double.js";
import { Component, createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { ofArray } from "../fable_modules/fable-library-js.4.29.0/List.js";
import { SeasonModule_name } from "../Model/Crops.js";
import { obj_type, record_type, bool_type, lambda_type, class_type, unit_type, getCaseName } from "../fable_modules/fable-library-js.4.29.0/Reflection.js";
import { getItemFromDict } from "../fable_modules/fable-library-js.4.29.0/MapUtil.js";
import { QualityModule_name } from "../Model/Skills.js";
import { ProductModule_name } from "../Model/Items.js";
import { Record } from "../fable_modules/fable-library-js.4.29.0/Types.js";
import { map, item as item_1, setItem, mapIndexed, fill } from "../fable_modules/fable-library-js.4.29.0/Array.js";
import { contains } from "../fable_modules/fable-library-js.4.29.0/Set.js";
import { UIMessage } from "../Update.js";

export function ofOption(mapping, option) {
    return Option_defaultOrMap(defaultOf(), mapping, option);
}

export function round2(x) {
    return round(x, 2);
}

export function gold(g) {
    return g.toString() + "g";
}

export function gold2(gold_1) {
    return toText(printf("%.2fg"))(gold_1);
}

export function xpFloat(xp_1) {
    return xp_1.toString() + "xp";
}

export function xp(xp_1) {
    return xp_1.toString() + "xp";
}

export function percent(value) {
    const arg = value * 100;
    return toText(printf("%.0f%%"))(arg);
}

export function percent2(value) {
    const arg = value * 100;
    return toText(printf("%.2f%%"))(arg);
}

export function upperFirstChar(text) {
    return text.slice(0, 0 + 1).toLocaleUpperCase() + text.slice(1, text.length);
}

export function pluralize(text) {
    return text + "s";
}

export function pluralizeTo(value, text) {
    if (value === 1) {
        return text;
    }
    else {
        return pluralize(text);
    }
}

export function debouncer(timeout, f) {
    let last = undefined;
    return (value) => {
        iterate((handle) => {
            window.clearInterval(handle);
        }, toArray(last));
        last = window.setTimeout(() => {
            f(value);
        }, timeout);
    };
}

export function handleEvent(event) {
    event.stopPropagation();
    event.preventDefault();
}

export function clampIndex(array, index) {
    return max(0, min(array.length - 1, index));
}

export function Icon_Path_crop(seed, file) {
    return `img/Crops/${seed}/${file}.webp`;
}

export function Icon_Path_at(folder, file) {
    return `img/${folder}/${file}.webp`;
}

export const Icon_Path_fertilizer = (file) => Icon_Path_at("Fertilizers", file);

export function Icon_Path_item(itemId) {
    return Icon_Path_at("Items", itemId.toString());
}

export const Icon_Path_processor = (file) => Icon_Path_at("Processors", file);

export const Icon_Path_vendor = (file) => Icon_Path_at("Vendors", file);

export function Icon_growthStage(seed, item, stage) {
    return createElement("img", {
        alt: `${item.Name} Stage ${stage}`,
        src: Icon_Path_crop(seed, int32ToString(stage)),
    });
}

export function Icon_regrowStage(seed, item) {
    return createElement("img", {
        alt: `${item.Name} Regrow Stage`,
        src: Icon_Path_crop(seed, "Regrow"),
    });
}

function Icon_fromClassNameAndAlt(name, altText) {
    return createElement("img", {
        className: name.toLocaleLowerCase(),
        alt: altText,
    });
}

function Icon_fromClassName(name) {
    return Icon_fromClassNameAndAlt(name, "");
}

function Icon_messageWithChildren(name, children) {
    let elems;
    return createElement("span", createObj(ofArray([["className", "icon-message"], (elems = [Icon_fromClassName(name), createElement("span", {
        children: [children],
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function Icon_warningWith(children) {
    return Icon_messageWithChildren("warning", children);
}

export function Icon_errorWith(children) {
    return Icon_messageWithChildren("error", children);
}

function Icon_message(name, text) {
    return Icon_messageWithChildren(name, text);
}

export function Icon_warning(text) {
    return Icon_message("warning", text);
}

export function Icon_error(text) {
    return Icon_message("error", text);
}

function Icon_fromImageAndText(img, text) {
    return createElement("span", {
        className: "icon-text",
        children: reactApi.Children.toArray([img, text]),
    });
}

const Icon_fromClassAndName = (arg) => {
    const img = Icon_fromClassName(arg);
    return (text) => Icon_fromImageAndText(img, text);
};

function Icon_fromClassIsName(name) {
    return Icon_fromClassAndName(name)(name);
}

function Icon_fromPathAndAlt(path, altText) {
    return createElement("img", {
        className: "icon",
        src: path,
        alt: altText,
    });
}

function Icon_fromPath(path) {
    return Icon_fromPathAndAlt(path, "");
}

const Icon_fromPathAndName = (arg) => {
    const img = Icon_fromPath(arg);
    return (text) => Icon_fromImageAndText(img, text);
};

export const Icon_season = (arg) => Icon_fromClassIsName(SeasonModule_name(arg));

export function Icon_profession(profession) {
    return Icon_fromClassIsName(getCaseName(profession));
}

export const Icon_farming = Icon_fromClassIsName("Farming");

export const Icon_foraging = Icon_fromClassIsName("Foraging");

export const Icon_bearsKnowledge = Icon_fromClassAndName("bears-knowledge")("Bear\'s Knowledge");

export const Icon_specialCharm = Icon_fromClassAndName("special-charm")("Special Charm");

export const Icon_luckBuff = Icon_fromClassAndName("random")("Luck Buff");

export function Icon_item(item) {
    return Icon_fromPathAndName(Icon_Path_item(item.Id))(item.Name);
}

export function Icon_itemId(data, itemId) {
    return Icon_item(getItemFromDict(data.Items.fields[0], itemId));
}

export function Icon_seed(data, seed) {
    return Icon_itemId(data, seed * 1);
}

function Icon_withQuality(quality, name, img) {
    let elems;
    const qualityName = QualityModule_name(quality);
    return Icon_fromImageAndText(createElement("div", createObj(ofArray([["className", "quality"], (elems = [img, Icon_fromClassNameAndAlt(qualityName, (quality === 0) ? "" : (`${qualityName} quality`))], ["children", reactApi.Children.toArray(Array.from(elems))])]))), name);
}

export function Icon_itemQuality(item, quality) {
    return Icon_withQuality(quality, item.Name, Icon_fromPath(Icon_Path_item(item.Id)));
}

export function Icon_itemIdQuality(data, item, quality) {
    return Icon_itemQuality(getItemFromDict(data.Items.fields[0], item), quality);
}

export function Icon_productQuality(data, product, quality) {
    let matchResult, item;
    switch (product.tag) {
        case 4: {
            matchResult = 0;
            item = product.fields[0];
            break;
        }
        case 5: {
            matchResult = 0;
            item = product.fields[0].Item;
            break;
        }
        default:
            matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return Icon_itemIdQuality(data, item, quality);
        default: {
            const product_1 = product;
            const img = Icon_fromClassName(getCaseName(product_1));
            return Icon_withQuality(quality, ProductModule_name((key) => getItemFromDict(data.Items.fields[0], key), product_1), img);
        }
    }
}

export function Icon_fertilizerName(name) {
    return Icon_fromPathAndName(Icon_Path_fertilizer(name))(name);
}

export function Icon_fertilizer(fertilizer) {
    return Icon_fertilizerName(fertilizer.Name);
}

export function Icon_crop(data, _arg) {
    if (_arg.tag === 1) {
        return Icon_seed(data, _arg.fields[0].Seed);
    }
    else {
        return Icon_itemId(data, _arg.fields[0].Item);
    }
}

export function Icon_vendor(name) {
    return Icon_fromPathAndName(Icon_Path_vendor(name))(name);
}

export function Icon_processor(processor) {
    return Icon_fromImageAndText(createElement("img", {
        className: "icon-processor",
        src: Icon_Path_processor(processor),
        alt: "",
    }), processor);
}

export function Icon_NoText_season(season) {
    const name = SeasonModule_name(season);
    return Icon_fromClassNameAndAlt(name, name);
}

export function Icon_NoText_item(item) {
    return Icon_fromPathAndAlt(Icon_Path_item(item.Id), item.Name);
}

export function Icon_NoText_itemId(data, itemId) {
    return Icon_NoText_item(getItemFromDict(data.Items.fields[0], itemId));
}

export function Icon_NoText_vendor(name) {
    return Icon_fromPathAndAlt(Icon_Path_vendor(name), name);
}

export function Icon_NoText_processor(processor) {
    return createElement("img", {
        className: "icon-processor",
        src: Icon_Path_processor(processor),
        alt: processor,
    });
}

export function labelWith(css, label, element) {
    const children = ofArray([createElement("span", {
        className: css,
        children: label,
    }), element]);
    return createElement("label", {
        children: reactApi.Children.toArray(Array.from(children)),
    });
}

export function labelText(className, text, element) {
    return labelWith(className, text, element);
}

export function labeled(label, element) {
    return labelText("label-text", label, element);
}

export function labeledHidden(label, element) {
    return labelText("label-hidden", label, element);
}

class LazyHidden_LazyHiddenProps extends Record {
    constructor(Render, Visible) {
        super();
        this.Render = Render;
        this.Visible = Visible;
    }
}

function LazyHidden_LazyHiddenProps_$reflection() {
    return record_type("StardewValleyStonks.WebApp.View.Prelude.LazyHidden.LazyHiddenProps", [], LazyHidden_LazyHiddenProps, () => [["Render", lambda_type(unit_type, class_type("Fable.React.ReactElement", undefined))], ["Visible", bool_type]]);
}

class LazyHidden_LazyHidden extends Component {
    constructor(props) {
        super(props);
        this.rendered = false;
    }
    shouldComponentUpdate(next, _arg) {
        return next.Visible;
    }
    render() {
        const this$ = this;
        this$.rendered = (this$.rendered ? true : (this$.props).Visible);
        return this$.rendered ? (this$.props).Render() : defaultOf();
    }
}

function LazyHidden_LazyHidden_$reflection() {
    return class_type("StardewValleyStonks.WebApp.View.Prelude.LazyHidden.LazyHidden", undefined, LazyHidden_LazyHidden, class_type("Fable.React.Component`2", [LazyHidden_LazyHiddenProps_$reflection(), obj_type], Component));
}

function LazyHidden_LazyHidden_$ctor_45BC3791(props) {
    return new LazyHidden_LazyHidden(props);
}

function LazyHidden_view(visible, render) {
    const props = new LazyHidden_LazyHiddenProps(render, visible);
    return react.createElement(LazyHidden_LazyHidden, props);
}

function tabId(label, tab) {
    let str_1;
    return `${label.toLocaleLowerCase()}-tab-${(str_1 = getCaseName(tab), str_1.toLocaleLowerCase())}`;
}

export function Tabs(props) {
    let elems, elems_1;
    const tabs = props.Tabs;
    const current = props.Current;
    const dispatch = props.Dispatch;
    const label = props.Label;
    let tabRefs;
    const initialValue = fill(new Array(tabs.length), 0, tabs.length, undefined);
    tabRefs = (reactApi.useRef(initialValue));
    const xs_4 = [createElement("div", createObj(ofArray([["role", join(" ", ["tablist"])], ["aria-label", `${label} Tabs`], (elems = mapIndexed((i, tab) => {
        let array;
        const active = equals(current, tab);
        return createElement("button", {
            role: join(" ", ["tab"]),
            id: tabId(label, tab),
            ref: (array = tabRefs.current, (value_6) => {
                setItem(array, i, value_6);
            }),
            "aria-selected": active,
            tabIndex: active ? 0 : -1,
            onClick: (_arg) => {
                dispatch(tab);
            },
            onKeyDown: (e) => {
                let matchValue;
                iterate((i_1) => {
                    iterate((elm) => {
                        elm.focus();
                    }, toArray(item_1(i_1, tabRefs.current)));
                    dispatch(item_1(i_1, tabs));
                }, toArray((matchValue = e.key, (matchValue === "ArrowRight") ? ((i === (tabs.length - 1)) ? 0 : (i + 1)) : ((matchValue === "ArrowLeft") ? ((i === 0) ? (tabs.length - 1) : (i - 1)) : undefined))));
            },
            children: getCaseName(tab),
        });
    }, tabs), ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", createObj(ofArray([["role", join(" ", ["tabpanel"])], ["aria-labelledby", join(" ", [tabId(label, current)])], (elems_1 = map((tab_1) => {
        const active_1 = equals(tab_1, current);
        return createElement("div", createObj(toList(delay(() => {
            let str_1;
            return append(singleton(["id", `${label.toLocaleLowerCase()}-${(str_1 = getCaseName(tab_1), str_1.toLocaleLowerCase())}`]), delay(() => append(active_1 ? singleton(["className", "active"]) : empty(), delay(() => singleton(["children", LazyHidden_view(active_1, () => props.Panel(tab_1))])))));
        }))));
    }, tabs), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))];
    return react.createElement(react.Fragment, {}, ...xs_4);
}

function detailsSectionWith(openDetails, key, summaryContent, children, dispatch) {
    let str, elems;
    const open$0027 = contains(key, openDetails);
    const id = `${(str = getCaseName(key), str.toLocaleLowerCase())}-details`;
    return createElement("details", createObj(ofArray([["open", open$0027], ["onToggle", (e) => {
        let tupledArg;
        dispatch((tupledArg = [key, e.target.open], new UIMessage(4, [tupledArg[0], tupledArg[1]])));
    }], (elems = [createElement("summary", {
        children: [summaryContent],
    }), createElement("div", {
        id: id,
        children: children,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function detailsSection(openDetails, key, summary, children, dispatch) {
    return detailsSectionWith(openDetails, key, summary, children, dispatch);
}

export function lazyDetails(openDetails, key, summary, children, dispatch) {
    return detailsSectionWith(openDetails, key, summary, LazyHidden_view(contains(key, openDetails), children), dispatch);
}

//# sourceMappingURL=Prelude.js.map
